import Chart from './chart';

//const chart = new Chart({ ChartDiv: 'marketTest', MarketId: '56539231c7eb6e355878befc', TimeLevel: { value: 1 }, SelectedEndDate: '', SelectedStartDate: '', CurrentStudy: { value: 1 } });
//chart.load();

($ as any).aeChart = (props: any) => {
    return new Chart(props);
}

export default Chart;